import type { FC } from "react";

import { Combobox } from "@/ui/components/form";
import type {
  TArticleCategoryFilterProps,
} from "@/ui/components/sections/articles/ArticleCategoryFilter/ArticleCategoryFilter.config";
import {
  useArticleCategoryFilter,
} from "@/ui/components/sections/articles/ArticleCategoryFilter/useArticleCategoryFilter";
import {
  useFiltersStore,
} from "libs/state/src/lib/stores/tanstack/filters/useFiltersStore";
import { InputFieldSkeleton } from "@/ui/components/primitives";

export const ArticleCategoryFilter: FC<TArticleCategoryFilterProps> = (
  { options, isLoading },
) => {
  const { label, placeholder, onUpdateSelectedCategories } = useArticleCategoryFilter();
  const { filters } = useFiltersStore();

  return (
    <div data-component="ArticleCategoryFilter" className="w-full">
      { isLoading ? (
        <InputFieldSkeleton />
      ): (
        <Combobox
          options={options}
          label={label}
          placeholder={placeholder}
          isMultiSelect
          hideLabel
          value={ filters.articles["articles:categories"] }
          onValueChange={onUpdateSelectedCategories}
        />
      ) }
    </div>
  );
};
